/*
 * @Description: axios 封装
 * @Author: mdb
 * @Date: 2022-05-24 09:38:09
 * @LastEditTime: 2023-04-21 14:43:45
 * @LastEditors: mdb
 */
import Qs from 'qs'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { bridge } from '@dc-platform/dc-bridge'
import { message } from '@dc-platform/dc-components'
// import { isObject, pickBy } from 'lodash-es'
import { getUrlParam } from '@/utils/index'
import { signatureFn } from '@/utils/signature'
import { AxiosResult } from '@/typings/common'
import { getLanguage } from '@/lang'
import { getCurrentTimeZone } from '@/utils/timeFormat'
import settings from '@/settings'

interface CustomRequestConfig extends AxiosRequestConfig {
  custom?: { errorMsg?: boolean }
}

// 全局自定义参数默认值（使用custom对象，便于后期拓展）
const custom = {
  errorMsg: true // 是否自动弹出错误信息
}

// 创建一个axios实例
const service = axios.create({
  baseURL: (<any>window).API_URL, // process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 1000 * 60 * 10 // 10分钟超时
})

// 这里需要接入dc进行初始化请求
bridge.handleAxiosBefore(service)

// 请求拦截器
service.interceptors.request.use(
  (config: CustomRequestConfig) => {
    // 添加自定义参数
    config.custom = { ...custom, ...config.custom }

    // 去掉参数空值：null、undefined、''
    // if (isObject(config.params)) {
    //   config.params = pickBy(config.params, (item) => item != null && item !== '')
    // }
    // if (
    //   isObject(config.data) &&
    //   !Array.isArray(config.data) &&
    //   Object.prototype.toString.call(config.data) !== '[object FormData]'
    // ) {
    //   config.data = pickBy(config.data, (item) => item != null && item !== '')
    // }

    // Authorization：授权信息，等同于token
    // locale_language：语言标识，对应值见文尾
    // time：时间戳，13位长整形
    // requestId：8位字符的请求ID，随机串
    // appId：应用ID，一般由应用向网关申请
    // caller：调用方，一般可为应用名
    // version：版本号
    // sign：签名

    // const language = sessionStorage.getItem('language') || 'zh-CN' 后台接收的不是下划线，前端多语言是下划线，加上做多语言需要转换
    const language = getUrlParam('lang') || getLanguage()
    // 接口验签  header字段为请求头必须参数 然后加上sign字段（拿到头参数. 请求参数 .url?参数的一个签名）
    const { url } = config
    const urlParams = Qs.parse((url as string).split('?')[1])
    const header = {
      time: Number((new Date().getTime() / 1000).toFixed(0)),
      api: url as string, // 当前时间戳 秒
      requestId: String(Math.random()).substring(2, 10),
      appId: 'z9b5f4cd-0e8c-42je-bb0h-cfbe486b569g',
      caller: 'cos',
      version: '1.0'
    }

    // 如果是市场营销的接口，需要加上子业务域
    let subdomain = ''
    const { href } = window.location
    try {
      const subApp = getUrlParam('subdomain') || href.split('/')[4] // 优先获取 URL 参数值，其次获取当前路径值
      const appEnum = { fbu: 'cos_fbu', lbu: 'cos_lbu', ofbu: 'cos_ofbu' }
      appEnum[subApp] && (subdomain = appEnum[subApp])
      if (config.url?.includes('/zbu/api/') && subdomain) {
        if (config.method === 'get') {
          config.params = { ...config.params, subdomain }
        } else {
          // 发送数据是FormData时，不需要添加 subdomain 参数
          config.data = config.data instanceof FormData ? config.data : { ...config.data, subdomain }
        }
      }
    } catch (error) {
      console.log('获取子业务域：', error)
    }

    config.headers = {
      ...config.headers,
      ...header
    }
    let signParams = {}
    if (config.method === 'get') {
      signParams = { ...header, ...urlParams, ...config.params }
    } else {
      signParams = { ...header, param: config.data, ...urlParams }
    }
    config.headers.sign = signatureFn(signParams, settings.signKey)
    config.headers.locale_language = config.headers.locale_language || language
    config.headers.browser_time_zone = getCurrentTimeZone()
    config.headers.subdomain = config.headers.subdomain || subdomain // 子业务域

    return config
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    const res: AxiosResult = response.data
    return new Promise((resolve, reject) => {
      // 判断是否处理报错提示
      const config = response.config as CustomRequestConfig
      if (config.custom?.errorMsg === false) return resolve(res)

      // 文件流
      if (res.code !== 200) {
        // 错误处理
        message.error(res.message)
        reject(response)
      } else {
        resolve(res)
      }
    })
  },
  (error) => {
    message.error(error.message)
    console.log('err' + error)
    return Promise.reject(error)
  }
)

export default service
